<template>
  <div>
    <navs></navs>
    <div class="bannerBox">
      <van-swipe :autoplay="3000">
        <van-swipe-item>
          <div class="banner3"></div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner2"></div>
        </van-swipe-item>

        <van-swipe-item>
          <div class="banner4"></div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner1"></div>
        </van-swipe-item>
      </van-swipe>
      <div class="bannerTitle">智慧物流，一站式供应链服务平台</div>
    </div>


    <!--携船网-->
    <div class="marT"></div>
    <p class="companyName" style="margin:0 !important;">一站式供应链服务平台</p>
    <p class="subTitle fs11" style="color: #666666ab !important;">水陆多式联运、物流可视化、数智化，助力企业降本增效</p>
    <van-swipe class="footer-swipe" :autoplay="3000">
      <van-swipe-item class="swipe-item">
        <div class="swipe-item-box">
          <div id="anime_icon" class="anime-icon icon1"></div>
          <p class="swipe-item-title">物流大数据</p>
          <p class="swipe-item-subTitle">基于全球船载AIS、卫星定位、船舶登记档案、道路运输车辆及平台交易数据，实现货车、船舶数据多维度分析与监测</p>
        </div>
      </van-swipe-item>
      <van-swipe-item class="swipe-item">
        <div class="swipe-item-box">
          <div id="anime_icon" class="anime-icon icon2"></div>
          <p class="swipe-item-title">智能匹配</p>
          <p class="swipe-item-subTitle">根据货物特性、运输计划及航线，快速精准调度，提升找船、找车效率</p>
        </div>
      </van-swipe-item>
      <van-swipe-item class="swipe-item">
        <div class="swipe-item-box">
          <div id="anime_icon" class="anime-icon icon3"></div>
          <p class="swipe-item-title">可视化管理</p>
          <p class="swipe-item-subTitle">监控在途运输信息，追溯历史轨迹，运输业务全流程可视化跟踪与管理</p>
        </div>
      </van-swipe-item>
      <van-swipe-item class="swipe-item">
        <div class="swipe-item-box">
          <div id="anime_icon" class="anime-icon icon4"></div>
          <p class="swipe-item-title">安全高效</p>
          <p class="swipe-item-subTitle">交易实名认证、电子合同签约、7*24小时运费秒到结算、交易信息加密保护</p>
        </div>
      </van-swipe-item>
    </van-swipe>

    <div class="dataBox">
      <div class="row mt35">
        <div class="column">
          <img src="../assets/nowDay.png"/>
          <div class="flex">
            <roll-number ref="nowDay" :targetNumber="nowData"></roll-number>
            <span class="unit">艘</span>
          </div>
          <span class="tip">今日活跃船舶</span>
        </div>
        <img class="icon-fg" src="../assets/icon-fg.png"/>
        <div class="column">
          <img src="../assets/month.png"/>
          <div class="flex">
            <roll-number ref="month" :targetNumber="monthData"></roll-number>
            <span class="unit">艘</span>
          </div>
          <span class="tip">月度活跃船舶</span>
        </div>
      </div>
      <div class="row mt70">
        <div class="column">
          <img src="../assets/ship.png"/>
          <div class="flex">
            <roll-number ref="ship" :targetNumber="20000"></roll-number>
            <span class="unit">+</span>
          </div>
          <span class="tip">货船档案</span>
        </div>
        <img class="icon-fg" src="../assets/icon-fg.png"/>
        <div class="column">
          <img src="../assets/car.png"/>
          <div class="flex">
            <roll-number ref="car" :targetNumber="5000000"></roll-number>
            <span class="unit">+</span>
          </div>
          <span class="tip">运输车辆</span>
        </div>
      </div>
      <div class="row mt70">
        <div class="column">
          <img src="../assets/people.png"/>
          <div class="flex">
            <roll-number ref="people" :targetNumber="200000"></roll-number>
            <span class="unit">+</span>
          </div>
          <span class="tip">平台从业人员</span>
        </div>
        <img class="icon-fg" src="../assets/icon-fg.png"/>
        <div class="column">
          <img src="../assets/goodsMan.png"/>
          <div class="flex">
            <roll-number ref="goodsMan" :targetNumber="10000"></roll-number>
            <span class="unit">+</span>
          </div>
          <span class="tip">合作货主</span>
        </div>
      </div>
    </div>
    <!--        <van-tabs :ellipsis=false animated class="tabsConter">-->
    <!--            <van-tab v-for="(item,index) in tabName" :title="item" :key="item" >-->
    <!--               <div v-if="index == 0" class="introBox">-->
    <!--                   <img src="../assets/xie1.png" class="introImg">-->
    <!--                   <p class="smend">-->
    <!--                     与国内知名银行、金融保险机构及地方政府深度合作，拥有充裕的现金流及财政奖励政策，通过平台运输交易可享受运费垫资、电子合同签约、运费7*24小时在线支付、在线投保等服务，共享财政奖励优惠，降低运输交易及融资成本                   </p>-->
    <!--               </div>-->
    <!--                <div v-if="index == 1" class="introBox">-->
    <!--                   <img src="../assets/xie2.png" class="introImg">-->
    <!--                   <p class="smend">-->
    <!--                      提供船舶融资租赁、抵押贷款、运费垫资等金融服务，同时携手国内知名保险经纪公司，无缝衔接各大保险网销渠道，用户可随时通过手机完成下单、支付、查询、理赔等全流程服务，让保险触手可及-->
    <!--                   </p>-->
    <!--               </div>-->
    <!--                <div v-if="index == 2" class="introBox">-->
    <!--                   <img src="../assets/xie3.png" class="introImg">-->
    <!--                   <p class="smend">-->
    <!--                       10年+专业船舶管理团队，建立科学、严谨、建全的管理体系，帮助航行线路分析决策，故障技术支持，并辅以航运大数据系统，全天候智能预警，为船舶安全航行保驾护航-->
    <!--                   </p>-->
    <!--               </div>-->
    <!--                <div v-if="index == 3" class="introBox">-->
    <!--                   <img src="../assets/xie4.png" class="introImg">-->
    <!--                   <p class="smend">-->
    <!--                       航运大数据是基于AIS、官方船舶数据以及用户数据，运用物联网、云计算及人工智能等技术，结合数据挖掘、深度学习、智能预测等算法，实现对船舶多维度分析，对提升船货运输效率，船舶安全管理、业务可视化跟踪、业务精准推广等，具有重要的商业价值-->
    <!--                   </p>-->
    <!--               </div>-->
    <!--&lt;!&ndash;                <div v-if="index == 4" class="introBox">&ndash;&gt;-->
    <!--&lt;!&ndash;                   <img src="../assets/xie5.png" class="introImg">&ndash;&gt;-->
    <!--&lt;!&ndash;                   <p class="smend">&ndash;&gt;-->
    <!--&lt;!&ndash;                       易拍船为船舶商业拍卖竞价系统，专业的服务团队提供一站式全流程服务。客户委托出售，平台委派专业评估团队进行实船勘验并出具报告，多渠道精准推广，让船舶溢价增值。拍卖成功后，平台协助办理交接手续，资金统一监管保障交易安全&ndash;&gt;-->
    <!--&lt;!&ndash;                   </p>&ndash;&gt;-->
    <!--&lt;!&ndash;               </div>&ndash;&gt;-->
    <!--                <div v-if="index == 4" class="introBox">-->
    <!--                   <img src="../assets/xie6.png" class="introImg">-->
    <!--                   <p class="smend">-->
    <!--                       平台提供简单易用的SaaS供应链管理系统，结合航运大数据，对客户、货物、船舶进行全流程分析、跟踪与预测，帮助企业实现数字化、可视化管理，供应链高效协同，降低运营成本-->
    <!--                    </p>-->
    <!--               </div>-->
    <!--            </van-tab>-->
    <!--    </van-tabs>-->
    <!--承运通-->
    <!--        <div class="beidouBox">-->
    <!--            <p class="beiName">承运通</p>-->
    <!--            <van-swipe :loop="false" :width="240" :class="[{'swipeBox':index1},{'swipeBox1':index2},{'swipeBox2':index3},{'swipeBox3':index4},{'swipeBox4':index5},]" ref="beiSwipe" @change="onChangeBanner">-->
    <!--                    <van-swipe-item >-->
    <!--                        <div class="beiInner">-->
    <!--                            <img src="../assets/bei1.png" class="beiImg">-->
    <!--                            <p class="beiTitle">货运大数据</p>-->
    <!--                            <p class="beiIntro">基于全国300万+货运车辆数据及卫星定位系统,结合全国道路货运车辆公共监管与服务平台,通过深度挖掘、人工智能、云计算分析车辆航行偏好、货物流向、车货信息等数据，实现快速找车找货、实现数字化、智能化、可视化管理</p>-->
    <!--                        </div>-->
    <!--                    </van-swipe-item>-->
    <!--                    <van-swipe-item>-->
    <!--                         <div class="beiInner">-->
    <!--                            <img src="../assets/bei2.png" class="beiImg">-->
    <!--                            <p class="beiTitle">金融保险</p>-->
    <!--                            <p class="beiIntro">解决承接国企或大型企业的运输业务,运费付款账期差异化问题,发挥自身资金实力优势和金融机构合作资源优势,降低客户融资成本.同时提供在线投保服务,便捷省心</p>-->
    <!--                        </div>-->
    <!--                    </van-swipe-item>-->
    <!--                    <van-swipe-item>-->
    <!--                        <div class="beiInner">-->
    <!--                            <img src="../assets/bei3.png" class="beiImg">-->
    <!--                            <p class="beiTitle">加油卡</p>-->
    <!--                            <p class="beiIntro">平台与中石化、中石油合作定制联名加油卡,将供应商的折扣和平台统一结算取得油票进项抵扣税金让利给充值船东、司机,让船东、司机取得更多的加油折扣</p>-->
    <!--                        </div>-->
    <!--                    </van-swipe-item>-->
    <!--                    <van-swipe-item>-->
    <!--                        <div class="beiInner">-->
    <!--                            <img src="../assets/bei4.png" class="beiImg">-->
    <!--                            <p class="beiTitle">ETC</p>-->
    <!--                            <p class="beiIntro">平台与高速公路合作,为货车司机代办ETC业务,并统一办理ETC 充值,平台取得折扣和通行费发票抵扣税收,让利一部分给司机,降低货车通行费成本</p>-->
    <!--                        </div>-->
    <!--                    </van-swipe-item>-->
    <!--                    <van-swipe-item>-->
    <!--                        <div class="beiInner">-->
    <!--                            <img src="../assets/bei5.png" class="beiImg">-->
    <!--                            <p class="beiTitle">交易结算</p>-->
    <!--                            <p class="beiIntro">依照国税总(2017)579 文件规定,取得互联网平台代开发票试点企业资格,平台系统与税务系统对接,可直接为个体司机,船东代开3%增值税专票,平台取得政府税收补贴,让利给用户,降低税负成本</p>-->
    <!--                        </div>-->
    <!--                    </van-swipe-item>-->

    <!--            </van-swipe>-->
    <!--        </div>-->
    <!--合作伙伴-->
    <div>
      <p class="companyName">合作伙伴</p>
      <div class="partner">
        <div class="boderR">
          <img src="../assets/pn-1.png">
        </div>
        <div class="boderR">
          <img src="../assets/pn-2.png">
        </div>
        <div>
          <img src="../assets/pn-3.png">
        </div>
      </div>
      <div class="partner">
        <div class="boderR">
          <img src="../assets/pn-4.png">
        </div>
        <div class="boderR">
          <img src="../assets/pn-5.png">
        </div>
        <div>
          <img src="../assets/pn-6.png">
        </div>
      </div>
      <div class="partner">
        <div class="boderR">
          <img src="../assets/pn-7.png">
        </div>
        <div class="boderR">
          <img src="../assets/pn-8.png">
        </div>
        <div>
          <img src="../assets/pn-9.png">
        </div>
      </div>
      <div class="partner">
        <div class="boderR">
          <img src="../assets/pn-10.png">
        </div>
        <div class="boderR">
          <img src="../assets/pn-11.png">
        </div>
        <div>
          <img src="../assets/pn-12.png">
        </div>
      </div>
      <div class="partner" style="border-bottom:0">
        <div class="boderR">
          <img src="../assets/pn-13.png">
        </div>
        <div class="boderR">
          <img src="../assets/pn-14.png">
        </div>
        <div>
          <img src="../assets/pn-15.png">
        </div>
      </div>
    </div>
    <div style="margin-top:1rem"></div>

    <foot></foot>
    <rightC></rightC>
  </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
import rollNumber from "@/components/nav/rollNumber";

export default {
  data() {
    return {
      tabName: ["交易结算", "金融保险", "船舶管理", "船舶大数据", "供应链管理"],//"船舶交易",
      index1: true,
      index2: false,
      index3: false,
      index4: false,
      index5: false,
      nowData: 151759,
      monthData: 848988,
    }
  },
  components: {
    navs, foot, rightC, rollNumber
  },
  created() {
    let self = this;
    let xhr1 = new XMLHttpRequest();
    xhr1.open("GET", "https://image.xcw9898.com/json/totalShipActiveArray.json", true);
    xhr1.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhr1.onload = function () {
      if (xhr1.readyState === 4 && xhr1.status === 200) {
        let jsonData = JSON.parse(xhr1.responseText);
        self.nowData = jsonData[0].total + 200000;
      }
    };
    xhr1.send();

    let xhr2 = new XMLHttpRequest();
    xhr2.open("GET", "https://image.xcw9898.com/json/totalShipActiveArrayMonth.json", true);
    xhr2.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhr2.onload = function () {
      if (xhr2.readyState === 4 && xhr2.status === 200) {
        let jsonData = JSON.parse(xhr2.responseText);
        self.monthData = jsonData[0].total + 100000;
      }
    };
    xhr2.send();

    window.addEventListener('scroll', function() {
      let scrollPosition = window.scrollY;
      if (scrollPosition >= 200) {
        self.$refs.nowDay.init();
        self.$refs.month.init();
        self.$refs.car.init();
        self.$refs.ship.init();
        self.$refs.people.init();
        self.$refs.goodsMan.init();
      }
    });
  },
  methods: {
    onChangeBanner(index) {
      if (index == 0) {
        this.index1 = true
        this.index2 = false;
        this.index3 = false;
        this.index4 = false;
        this.index5 = false;
      } else if (index == 1) {
        this.index1 = false;
        this.index2 = true;
        this.index3 = false;
        this.index4 = false;
        this.index5 = false;
      } else if (index == 2) {
        this.index1 = false;
        this.index2 = false;
        this.index3 = true;
        this.index4 = false;
        this.index5 = false;
      } else if (index == 3) {
        this.index1 = false;
        this.index2 = false;
        this.index3 = false;
        this.index4 = true;
        this.index5 = false;
      } else {
        this.index1 = false;
        this.index2 = false;
        this.index3 = false;
        this.index4 = false;
        this.index5 = true;
      }
    }

  }
}
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
.bannerBox {
  position: relative;

  .banner1 {
    width: 100%;
    height: 10rem;
    background: url('../assets/index-b1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left center;
    text-align: center;
    line-height: 10rem;
    color: #fff;
    font-size: 18/@rem;
  }

  .banner2 {
    width: 100%;
    height: 10rem;
    background: url('../assets/index-b2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left center;
    text-align: center;
    line-height: 10rem;
    color: #fff;
    font-size: 18/@rem;
  }

  .banner3 {
    width: 100%;
    height: 10rem;
    background: url('../assets/index-b3.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left center;
    text-align: center;
    line-height: 10rem;
    color: #fff;
    font-size: 18/@rem;
  }

  .banner4 {
    width: 100%;
    height: 10rem;
    background: url('../assets/index-b4.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left center;
    text-align: center;
    line-height: 10rem;
    color: #fff;
    font-size: 18/@rem;
  }

  .bannerTitle {
    position: absolute;
    left: 50%;
    color: #fff;
    top: 50%;
    height: 19px;
    margin-top: -14.5px;
    //width: 244/@rem;
    margin-left: -(264/@rem)/2;
    font-size: 18/@rem;


  }
}

.marT {
  margin-top: 30/@rem
}

.companyName {
  color: #333;
  font-size: 18/@rem;
  text-align: center;
}

.subTitle {
  color: #FFFFFF;
  font-size: 12/@rem;
  text-align: center;
  margin-top: 10/@rem;
  margin-bottom: 0 !important;
}

.introBox {
  text-align: center;

  .introImg {
    width: 180/@rem;
    height: auto;
    display: inline;
    margin-top: 28/@rem;

  }

  .smend {
    color: #666666;
    font-size: 14px;
    //    font-size: 0.85rem;
    padding-left: 20/@rem;
    padding-right: 20/@rem;
    //    line-height: 24/@rem;
    line-height: 24px;
    text-align: justify;
  }
}

.beidouBox {
  width: 100%;
  height: 310/@rem;
  background-image: url('../assets/bei-bg.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ceil(100%) ceil(100%);

}

.beiName {
  font-size: 18/@rem;
  text-align: center;
  color: #fff;
  padding-top: 26/@rem;
  padding-bottom: 14/@rem
}

.beiInner {
  width: 180/@rem;
  height: 180/@rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5/@rem;
  margin-left: 20/@rem;
  text-align: center;

  .beiImg {
    width: 24/@rem;
    padding-top: 12/@rem

  }

  .beiTitle {
    font-size: 14/@rem;
    color: #fff;
    margin: 0
  }

  .beiIntro {
    font-size: 9/@rem;
    color: #fff;
    margin: 0;
    padding: 10/@rem 14/@rem;
    text-align: left;
    //   text-align: justify;
    //   text-align-last: center;
    line-height: 16/@rem
  }

}

.partner {
  display: flex;
  justify-content: space-between;
  margin-left: 10/@rem;
  margin-right: 10/@rem;
  border-bottom: 1px solid rgba(230, 230, 230, 1);

  div {
    flex: 1;
    height: 50/@rem;
    align-items: center;
    text-align: center;
    line-height: 50/@rem;

    img {
      width: 84/@rem;
      display: inline-block;
      margin-top: 0.8rem
    }
  }

  .boderR {
    border-right: 1px solid rgba(230, 230, 230, 1);

  }
}

.swipeBox {
  height: 13.5rem;
  width: 100%;

  .van-swipe-item {
    width: 210/@rem;
  }

  .van-swipe__track {
    transform: translateX(0px) !important;
  }

}

.swipeBox1 {
  height: 13.5rem;
  width: 100%;

  .van-swipe-item {
    width: 210/@rem;
  }

  .van-swipe__track {
    transform: translateX(-240px) !important;
  }
}

.swipeBox2 {
  height: 13.5rem;
  width: 100%;

  .van-swipe-item {
    width: 210/@rem;
  }

  .van-swipe__track {
    transform: translateX(-480px) !important;
  }
}

.swipeBox3 {
  height: 13.5rem;
  width: 100%;

  .van-swipe-item {
    width: 210/@rem;
  }

  .van-swipe__track {
    transform: translateX(-720px) !important;
  }
}

.swipeBox4 {
  height: 13.5rem;
  width: 100%;

  .van-swipe-item {
    width: 210/@rem;
  }

  .van-swipe__track {
    transform: translateX(-880px) !important;
  }
}

.tabsConter {
  .van-tabs__wrap--scrollable .van-tab {
    -webkit-box-flex: none;
    -webkit-flex: none;
    flex: none;
  }

  .van-tab {
    padding-right: 15px;
    padding-left: 15px;
    // font-size: 0.85rem;
  }

}

.swipe-item {
  width: 100%;
}

.swipe-item-box {
  margin: 15/@rem auto 20/@rem auto;
  width: 280/@rem;
  height: 219/@rem;
  background: rgba(255, 255, 255);
  box-shadow: 0px 0px 10/@rem rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10/@rem 20/@rem;
  box-sizing: border-box;
}

.swipe-item-title {
  font-size: 16/@rem;
  color: #333333;
  margin: 10/@rem 0 !important;
}

.fs11 {
  font-size: 11/@rem !important;
}

.swipe-item-subTitle {
  font-size: 11/@rem;
  color: #666666ab;
  margin: 0 !important;
  text-align: center;
}

.anime-icon {
  width: 127px;
  height: 150px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-y: 0;
  animation: mouse-in 2.08s;
  animation-timing-function: steps(67, end);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-direction: alternate;
}

.icon1 {
  background-image: url('../assets/wldsj.jpg');
}

.icon2 {
  background-image: url('../assets/znpp.jpg');
}

.icon3 {
  background-image: url('../assets/kshgl.jpg');
}

.icon4 {
  background-image: url('../assets/aqgx.jpg');
}

@keyframes mouse-in {
  from {
    background-position-y: 0;
  }
  to {
    background-position-y: -10050px;
  }
}

.dataBox {
  height: 524 /@rem;
  width: 100%;
  background: url('../assets/data-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 70/@rem 20/@rem;
  box-sizing: border-box;
}

.row {
  display: flex;
  align-items: center;
}

.icon-fg {
  width: 1/@rem;
  height: 35/@rem;
  margin: 0 20/@rem;
}

.column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 200/@rem;
}

.count {
  font-size: 26/@rem;
  font-weight: bold;
  color: #FFFFFF;
}

.column img {
  height: 23/@rem;
  width: 23/@rem;
}

.unit {
  margin-left: 5/@rem;
  font-size: 13/@rem;
  font-family: Microsoft YaHei, sans-serif;
  line-height: 25px;
  color: #FFFFFF;
}

.tip {
  font-size: 11/@rem;
  font-family: Microsoft YaHei, serif;
  color: #198CFF;
}

.mt35 {
  margin-top: 10/@rem;
}

.mt70 {
  margin-top: 70/@rem;
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue